module.exports = __webpack_public_path__ + "img/1.584df38b.jpeg";